import { useState, useEffect, useRef } from "react";
import {
    Card,
    Col,
    Row,Button,Table,Menu,
    message,
    Form
} from "antd";
import { SearchOutlined } from '@ant-design/icons';
import { FormOutlined} from '@ant-design/icons';
import { Input, Space } from 'antd';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { all_data, deleteUser, updateUserPass } from "../store/action/users";
import Highlighter from 'react-highlight-words'
import StyleDropdown from "../components/forms/dropdown";
import InputPassword from '../components/forms/inputPassword';
import InputConfirmPassword from '../components/forms/inputConfirmPassword';
import StyleModal from "../components/modal";
import FormButton from "../components/forms/button";
// table code start



 
  
  function Users() {
    const dispatch = useDispatch()
    const users = useSelector(state => state.users.data, shallowEqual)

      // table filter
      const [searchText, setSearchText] = useState('');
      const [searchedColumn, setSearchedColumn] = useState('');
      const [updatePassword, setUpdatePassword] = useState(0);
      const searchInput = useRef(null);
      const handleSearch = (selectedKeys, confirm, dataIndex) => {
          confirm();
          setSearchText(selectedKeys[0]);
          setSearchedColumn(dataIndex);
      };
      const handleReset = (clearFilters) => {
          clearFilters();
          setSearchText('');
      };
      const getColumnSearchProps = (dataIndex) => ({
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
              <div
                  style={{
                      padding: 8,
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
              >
                  <Input
                      ref={searchInput}
                      placeholder={`Search ${dataIndex}`}
                      value={selectedKeys[0]}
                      onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                      onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                      style={{
                          marginBottom: 8,
                          display: 'block',
                      }}
                  />
                  <Space>
                      <Button
                          type="primary"
                          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                          icon={<SearchOutlined />}
                          size="small"
                          style={{
                              width: 90,
                          }}
                      >
                          Search
                      </Button>
                      <Button
                          onClick={() => clearFilters && handleReset(clearFilters)}
                          size="small"
                          style={{
                              width: 90,
                          }}
                      >
                          Reset
                      </Button>
                  </Space>
              </div>
          ),
          filterIcon: (filtered) => (
              <SearchOutlined
                  style={{
                      color: filtered ? '#0a2471' : undefined,
                  }}
              />
          ),
          onFilter: (value, record) =>
              record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownOpenChange: (visible) => {
              if (visible) {
                  setTimeout(() => searchInput.current?.select(), 100);
              }
          },
          render: (text) =>
              searchedColumn === dataIndex ? (
                  <Highlighter
                      highlightStyle={{
                          backgroundColor: '#ffc069',
                          padding: 0,
                      }}
                      searchWords={[searchText]}
                      autoEscape
                      textToHighlight={text ? text.toString() : ''}
                  />
              ) : (
                  text
              ),
      });
      // table filter

    useEffect(()=>{
      dispatch(all_data())
    },[dispatch])
    
    const deleteOrder = (id) =>{
        var confirmed = window.confirm("Are you sure you want to proceed?");
        if (confirmed) {
        deleteUser(id).then(res =>{
          if(res.status){
            dispatch(all_data())
            message.success("Successfully deleted")
          }
        })
        .catch(e => message.error("Failed to delete"))
        } 
    }

    const updateUserPassword = (value) =>{
      const newValue  = {...value, id : updatePassword};
      updateUserPass(newValue)
      .then(val =>{
        if(val.status){
          message.success(val.message)
          setUpdatePassword(0)
        }
        else{
          message.error(val.message)
          setUpdatePassword(0)
        }
      })
      .catch(res => message.error('Something went wrong'))
    }

    const columns = [
      {
        title: "Email",
        dataIndex: "username",
        key: "username",
        ...getColumnSearchProps('username')
      },
      {
        title: "Role",
        dataIndex: "user_role",
        key: "user_role"
      },
      {
        title: 'Actions',
        dataIndex: 'id',
        fixed: 'right',
        width: 150,
        render: (value, val) => {
              let menu = (
                    <Menu>
                        <Menu.Item onClick={()=> deleteOrder(value)}>Delete User</Menu.Item>
                        <Menu.Item onClick={()=> setUpdatePassword(value)}>Update Password</Menu.Item>
                    </Menu>
              )
            return (
                <StyleDropdown menu={menu} />
            )
        }
    },
    ];


    return (
      <>
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs="24" xl={24}>
              <Card
                bordered={false}
                className="criclebox tablespace mb-24"
                title={(<div className="style-row w-100"><h4 className="text-center">Users List</h4></div>)}
              >
                <div className="table-responsive">
                  {users && users.length > 0 &&
                  <Table
                    columns={columns}
                    dataSource={users}
                    pagination={false}
                    className="ant-border-space"
                  />
                  }
                </div>
              </Card>
            </Col>
          </Row>
        </div>
        {updatePassword !== 0 && <StyleModal view={updatePassword === 0 ? false : true}  footer={null} >
          <div className='create-form-inner modal-form'>
            <h2 className="heading">Change Password</h2>
                <Form
                    name="password-form"
                    className='password-form'
                    initialValues={{}}
                    onFinish={updateUserPassword}
                >
                     <Row gutter={10}>
                        <Col span={24} className="input-div">
                            <InputPassword name='password' icon={<FormOutlined />} message='Password' type="string" />
                        </Col>
                        <Col span={24} className="input-div">
                            <InputConfirmPassword name='confirm_password' icon={<FormOutlined />} message='Confirm Password' type="string" />
                        </Col>
                        <Col span={12} >
                          <FormButton value="Change" btntype="submit" />
                        </Col>       
                        <Col span={12} >
                            <FormButton value="Close" btntype="button"  onClick={()=>setUpdatePassword(0)} />
                        </Col>    
                    </Row>      
                </Form>
                </div>
        </StyleModal>
        }
      </>
    );
  }
  
  export default Users;
  